import * as actions from './actions'
import * as selectors from './selectors'
import reducers from './reducers'

export default {
  actions,
  selectors,
  reducers,
}
